<section class="public-page features-page">
  <div class="public-page-shell features-shell">
    <p class="public-page-kicker">{{ 'features.kicker' | translate }}</p>
    <h1 class="public-page-title">{{ 'features.title' | translate }}</h1>
    <p class="public-page-intro">{{ 'features.intro' | translate }}</p>

    <div class="public-page-grid public-page-grid--three feature-grid">
      <article class="public-page-card feature-card" *ngFor="let featureId of featureIds">
        <h2 class="public-page-card-title">{{ ('features.items.' + featureId + '.title') | translate }}</h2>
        <p class="public-page-card-text">{{ ('features.items.' + featureId + '.description') | translate }}</p>
      </article>
    </div>
  </div>
</section>
